import { render } from "./admin-on-behalf-of.vue?vue&type=template&id=70fdf7ce&scoped=true"
import script from "./admin-on-behalf-of.vue?vue&type=script&lang=js"
export * from "./admin-on-behalf-of.vue?vue&type=script&lang=js"

import "./admin-on-behalf-of.vue?vue&type=style&index=0&id=70fdf7ce&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fdf7ce"]])

export default __exports__